import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './app/core/Guards/auth.guard';
import { WOPrintPageComponent } from './app/modules/facility/maintenance/components/technical-support/wo-print-page/wo-print-page.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadChildren: () => import('./app/modules/shared/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./app/modules/shared/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'errors',
    loadChildren: () => import('./app/modules/shared/error/error.module').then((m) => m.ErrorModule),
  },
    { path: 'maintenance-order-bill/:id', component: WOPrintPageComponent },

  { path: '**', redirectTo: 'errors/404' },
];

export const AppRoutingModule = RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled', 
  preloadingStrategy: PreloadAllModules,
});